export default __webpack_public_path__ + "static/media/pollinationBeginsHere_v2.3dd1889d.jpg";